import { DescriptionStyle } from "./style"

 interface DescriptionProps {
    children: React.ReactNode;
    color?: string;
    align?: string;
    marginBottom?: string;
    margintop?: string;
    size?: string;
}
export const Description: React.FC<DescriptionProps> = ({ children, color, align, marginBottom, margintop: marginTop, size }) => {
    return (
        <DescriptionStyle $color={color} $align={align} $marginBottom={marginBottom} $marginTop={marginTop} $size={size}>
            {children}
        </DescriptionStyle>
    )
}